define('flight-components/mixins/withGeoSuggest',[
  'flight/lib/compose',
  'flight-components/mixins/withData',
  'hogan',
  'components/typeahead.js/dist/typeahead.bundle.min'
],
function(compose, withData, Hogan) {

  var withGeoSuggest = function withGeoSuggest() {

    compose.mixin(this, [withData]);

    this.initTypeahead = function() {
      var self = this;

      var template = Hogan.compile('<p data-dtm="change-location-suggest">{{location}}</p>');

      var geoSuggest = function() {
        return function findMatches(query, cb) {
          var matches = [];
          self.getJSON('/geoquery?term='+ query +'&count=15', function(response) {
            cb(response);
          });
        };
      };

      this.select('geoInputSelector').typeahead({
        hint: true,
        highlight: true,
        minLength: 2
      },
      {
        name: 'cities',
        displayKey: 'location',
        source: geoSuggest(),
        templates: {
          suggestion: function(location) {
            return template.render(location)
          }
        }
      });

      self.on('typeahead:opened', function(ev, location) {
        self.select('geoInputSelector').removeClass('error');
        self.select('errorMsgSelector').hide();
      })

      self.on('typeahead:selected', function(ev, location) {
        self.attr.selectedGeo = location;
      });

      self.on('typeahead:cursorchanged', function(ev, location) {
        self.attr.selectedGeo = location;
      });

      self.on('typeahead:autocompleted', function(ev, location) {
        self.attr.selectedGeo = location;
      });

    };

    this.after('initialize', function() {

      var self = this;
      if (self.attr.typeahead) {
        self.initTypeahead();
      }

      self.select('geoInputSelector').focus();

    });

  };

  return withGeoSuggest;

});
